import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Head = styled.h1`
	color: ${palette('white')};
	font-size: 36px;
	font-weight: 300;
	margin-bottom: 12px;
`;

export const Body = styled.p`
	color: ${palette('white')};
`;

export const Container = styled.div`
	position: relative;
	top: 45vh;
`;

export const Wrapper = styled.div`
	width: 100%;
	height: 90vh;
`;

export const ButtonPadding = styled.div`
	padding: 1.5rem 0;
`;

export const Grid = styled(GridWrapper)`
	min-height: 90vh;
	max-width: 480px;

	${minWidth('tablet')} {
		grid-template-columns: 1fr;
	}

	${minWidth('desktop')} {
		grid-template-columns: 1fr 1fr;
		max-width: 960px;
	}

	${minWidth('desktopLarge')} {
		max-width: 1168px;
	}
`;
